import { obterUsuarioLogadoLocal } from '../services/usuario-service';

export const checkUserRole = async (role) => {
    const usuarioLogado = await obterUsuarioLogadoLocal();
  
    return usuarioLogado && usuarioLogado?.authorities.some(authority => {
      return authority?.authority === role;
    });
  };